import type { ReactElement } from "react"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { PackagesComparisonSectionFlatData } from "@gatsby-plugin-generic-page/fragments/packagesComparisonSection"
import { Text } from "@ionos-web-design-system/react"
import ParametersTableUds from "~/components/ParametersTableUds"
import TogglePriceType from "~/components/TogglePriceType"
import isEmpty from "~/lib/isEmpty"

export default function PackagesComparisonSection({
  header,
  hasTogglePriceType,
  additionalText,
  isTextCentered,
  comparableProductsPackages,
  sectionSettings,
}: PackagesComparisonSectionFlatData): ReactElement<PackagesComparisonSectionFlatData> {
  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <div className="mb-4 text-left md:text-center">
            <Header {...header} />
          </div>
        ) : null}

        {hasTogglePriceType ? (
          <div className="mb-4 flex justify-end">
            <TogglePriceType />
          </div>
        ) : null}

        <ParametersTableUds packages={comparableProductsPackages} />

        {!isEmpty(additionalText) ? (
          <Text
            alignment={isTextCentered ? "center" : "left"}
            variant="bodySm"
            className="pt-5"
          >
            {additionalText}
          </Text>
        ) : null}
      </BaseContainer>
    </BaseSection>
  )
}
